import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams, Redirect } from "react-router-dom"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { withRouter } from "react-router";
import { Previe, FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import ApproveBloc from './Blocs/ApproveBloc'

var reformatType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.name;
      newObj["value"] = region.status;
      return newObj;
    });
  };

class IndexView extends Component {

    approveBloc = new ApproveBloc()

    constructor(props) {
        super(props)
        this.state = {
            submission_uuid: "",
            dataForm: {
                uuid: ""
            },
            typeItems:[],
            typeSelected:"",
            file_3023aa47_3d49_4c84_ac99_5c81cf448f7a : "",
            file_c2cbc042_1ed0_4eed_bd79_2927adb13654 : "",
            file_1371a1e2_ba77_4b55_b499_533fc3c38b34 : "",
            file_a4f92565_5b17_4982_a4b3_02b840137feb : "",
            file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6 : "",
            file_c22aca5e_dc5b_4990_962b_a33c48befbc7 : "",
            file_91221002_d1ef_4389_b9c5_583ab347968c : "",
            file_b8a77c68_3947_4c68_9a28_e8460d085284 : "",
            file_e5d65c2a_c480_4611_9a39_471411a87131 : "",
            file_be4336c7_55b7_4588_a4b7_1d4c1729311f : "",
            file_4782ec8f_3e28_464f_8ece_1763a70cfc2b : "",
            file_095579be_1bd9_45a1_b8cf_7e7c42110271 : "",
            file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213 : "",
            file_bfef60ea_811d_4f8f_a983_f46b60c55a33 : "",
            file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3 : "",
            file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60 : "",
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }  

    submitData = async () => {
        await this.approveBloc.fetchApprove(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })


        this.approveBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            submission_uuid: response.retired_employee_submission_uuid
                        })
                        //console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.approveBloc.documentChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response.result)
                        this.setState({
                            file_3023aa47_3d49_4c84_ac99_5c81cf448f7a : response.result.file_3023aa47_3d49_4c84_ac99_5c81cf448f7a,
                            file_c2cbc042_1ed0_4eed_bd79_2927adb13654 : response.result.file_c2cbc042_1ed0_4eed_bd79_2927adb13654,
                            file_1371a1e2_ba77_4b55_b499_533fc3c38b34 : response.result.file_1371a1e2_ba77_4b55_b499_533fc3c38b34,
                            file_a4f92565_5b17_4982_a4b3_02b840137feb : response.result.file_a4f92565_5b17_4982_a4b3_02b840137feb,
                            file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6 : response.result.file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6,
                            file_c22aca5e_dc5b_4990_962b_a33c48befbc7 : response.result.file_c22aca5e_dc5b_4990_962b_a33c48befbc7,
                            file_91221002_d1ef_4389_b9c5_583ab347968c : response.result.file_91221002_d1ef_4389_b9c5_583ab347968c,
                            file_b8a77c68_3947_4c68_9a28_e8460d085284 : response.result.file_b8a77c68_3947_4c68_9a28_e8460d085284,
                            file_e5d65c2a_c480_4611_9a39_471411a87131 : response.result.file_e5d65c2a_c480_4611_9a39_471411a87131,
                            file_be4336c7_55b7_4588_a4b7_1d4c1729311f : response.result.file_4782ec8f_3e28_464f_8ece_1763a70cfc2b,
                            file_4782ec8f_3e28_464f_8ece_1763a70cfc2b : response.result.file_4782ec8f_3e28_464f_8ece_1763a70cfc2b,
                            file_095579be_1bd9_45a1_b8cf_7e7c42110271 : response.result.file_095579be_1bd9_45a1_b8cf_7e7c42110271,
                            file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213 : response.result.file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213,
                            file_bfef60ea_811d_4f8f_a983_f46b60c55a33 : response.result.file_bfef60ea_811d_4f8f_a983_f46b60c55a33,
                            file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3 : response.result.file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3,
                            file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60 : response.result.file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.approveBloc.fetchDetail({uuid: queryParams.get('uuid') })
        this.approveBloc.fetchDocument({uuid: queryParams.get('uuid') })


        this.setState({
            typeItems: reformatType([
                {
                    name: "Ditolak",
                    status: -1
                },
                {
                    name: "Diterima",
                    status: 1
                }
            ]),
            dataForm: {
                uuid: queryParams.get('uuid')
            }
        })

    }
    


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Approval Usulan Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Usulan Pensiun
                                    </CardSubtitle>
                                    <hr />

                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >


                                    <AvField
                                        name="uuid"
                                        type="hidden"
                                        id="uuid"
                                        value={this.state.dataForm.uuid}
                                    />
                                   

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_nip !== "" ? this.state.detail.retired_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_name !== "" ? this.state.detail.retired_employee_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Unit Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_work_unit_name !== "" ? this.state.detail.retired_employee_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_position_name !== "" ? this.state.detail.retired_employee_position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_position_tmt !== "" ? this.state.detail.retired_employee_position_tmt : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Golongan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_level_name !== "" ? this.state.detail.retired_employee_level_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_birth_date !== "" ? this.state.detail.retired_employee_birth_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jenis Kelamin
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.gender_name !== "" ? this.state.detail.gender_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_retired_date !== "" ? this.state.detail.retired_employee_retired_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_retired_date_tmt !== "" ? this.state.detail.retired_employee_retired_date_tmt : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jenis
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_type_name !== "" ? this.state.detail.retired_type_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Usia
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_age !== "" ? this.state.detail.employee_age : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Usia Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_age_retired !== "" ? this.state.detail.employee_age_retired : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Sisa Masa Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_work_age !== "" ? this.state.detail.employee_work_age : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TUSK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_tusk !== "" ? this.state.detail.retired_employee_tusk : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        MPP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_mpp !== "" ? this.state.detail.retired_employee_mpp : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                <hr/>
                                <h4>Dokumen Persyaratan</h4>
                                <br/>

                                <Row className="mb-3">
                                        <label className="col-md-3">
                                        SUPERPDNA
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_be4336c7_55b7_4588_a4b7_1d4c1729311f ?
                                                    <>{this.state.file_be4336c7_55b7_4588_a4b7_1d4c1729311f !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_be4336c7_55b7_4588_a4b7_1d4c1729311f}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKP 1 TAHUN
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_4782ec8f_3e28_464f_8ece_1763a70cfc2b ?
                                                    <>{this.state.file_4782ec8f_3e28_464f_8ece_1763a70cfc2b !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_4782ec8f_3e28_464f_8ece_1763a70cfc2b}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SUPERHD
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_095579be_1bd9_45a1_b8cf_7e7c42110271 ?
                                                    <>{this.state.file_095579be_1bd9_45a1_b8cf_7e7c42110271 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_095579be_1bd9_45a1_b8cf_7e7c42110271}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKCP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213 ?
                                                    <>{this.state.file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_43da0758_0f3c_4cf0_a3be_c4db3f7ca213}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKCP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_bfef60ea_811d_4f8f_a983_f46b60c55a33 ?
                                                    <>{this.state.file_bfef60ea_811d_4f8f_a983_f46b60c55a33 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_bfef60ea_811d_4f8f_a983_f46b60c55a33}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKPMK
                                        </label>
                                        <Col md="9">
                                             {
                                                this.state.file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3 ?
                                                    <>{this.state.file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_3d712318_d1b4_483d_9a61_3bb74b3ea1b3}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKJF1
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60 ?
                                                    <>{this.state.file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_4ad488f6_4bc7_4cc3_b340_fbbac38bff60}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKJAB
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_3023aa47_3d49_4c84_ac99_5c81cf448f7a ?
                                                    <>{this.state.file_3023aa47_3d49_4c84_ac99_5c81cf448f7a !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_3023aa47_3d49_4c84_ac99_5c81cf448f7a}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKKPPI
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_c2cbc042_1ed0_4eed_bd79_2927adb13654 ?
                                                    <>{this.state.file_c2cbc042_1ed0_4eed_bd79_2927adb13654 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_c2cbc042_1ed0_4eed_bd79_2927adb13654}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKHENTINS
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_1371a1e2_ba77_4b55_b499_533fc3c38b34 ?
                                                    <>{this.state.file_1371a1e2_ba77_4b55_b499_533fc3c38b34 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_1371a1e2_ba77_4b55_b499_533fc3c38b34}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKCLTN
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_a4f92565_5b17_4982_a4b3_02b840137feb ?
                                                    <>{this.state.file_a4f92565_5b17_4982_a4b3_02b840137feb !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_a4f92565_5b17_4982_a4b3_02b840137feb}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKAKCLTN
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6 ?
                                                    <>{this.state.file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_ba08a2e1_7d68_4075_89c8_6455d6f1b4c6}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        DPCP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_c22aca5e_dc5b_4990_962b_a33c48befbc7 ?
                                                    <>{this.state.file_c22aca5e_dc5b_4990_962b_a33c48befbc7 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_c22aca5e_dc5b_4990_962b_a33c48befbc7}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKLANTIK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_91221002_d1ef_4389_b9c5_583ab347968c ?
                                                    <>{this.state.file_91221002_d1ef_4389_b9c5_583ab347968c !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_91221002_d1ef_4389_b9c5_583ab347968c}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        IJZAKHIR
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_b8a77c68_3947_4c68_9a28_e8460d085284 ?
                                                    <>{this.state.file_b8a77c68_3947_4c68_9a28_e8460d085284 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_b8a77c68_3947_4c68_9a28_e8460d085284}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        SKKPALL
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.file_e5d65c2a_c480_4611_9a39_471411a87131 ?
                                                    <>{this.state.file_e5d65c2a_c480_4611_9a39_471411a87131 !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.file_e5d65c2a_c480_4611_9a39_471411a87131}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <a href="#" class="btn btn-sm btn-secondary disabled"><i className="uil-file-download"></i> Download File</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <Select
                                                    value={this.state.typeItems.filter(option => 
                                                      option.value === this.state.typeSelected)}
                                                    onChange={
                                                      this.onChangeTypeSelected
                                                    }
                                                    required="required"
                                                    options={this.state.typeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Status Approval"
                                                />
                                                <AvField
                                                    name="status_approval"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval"
                                                    value={this.state.typeSelected}
                                                />
                                            </Col>
                                        </Row>

                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to={`?pegawai&uuid=`+this.state.submission_uuid}>
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                            {' '}
                                            <Button color="success" type="submit">
                                                <i className="uil-arrow-up-right"></i> Simpan Data
                                            </Button>
                                        </Col>
                                    </Row>


                                    </AvForm>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin ?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diverifikasi"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diverifikasi"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/pensiun.html?pegawai&uuid=`+this.state.submission_uuid}/>
                : null }                                     


            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);